import {
    PhoneCall,
    SupportActivity,
} from '@myrtls/api-interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import {
    getPhoneCallSuccessAction,
    getSiteActivitiesSuccessAction,
} from './support.actions';
import { selectSiteAction } from '../sites/sites.actions';

export interface SupportState {
    phoneCall: PhoneCall | null;
    activities: SupportActivity[];
}

const initialState: SupportState = {
    phoneCall: null,
    activities: [],
};

const reducer = createReducer(
    initialState,
    on(selectSiteAction, () => initialState),
    on(getPhoneCallSuccessAction, (state, { phoneCall }) => ({
        ...state,
        phoneCall,
    })),
    on(getSiteActivitiesSuccessAction, (state, { activities }) => ({
        ...state,
        activities,
    })),
);

export function supportReducer(
    state: SupportState | undefined,
    action: Action,
): SupportState {
    return reducer(state, action);
}
